import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const KoiiAirdropContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 0;
`;

const OutputText = styled.div`
    width: 100%;
    font-size: calc(8px + (12 - 8) * ((100vw - 300px) / (1600 - 300)));
    text-align: justify;
    word-wrap: break-word;
    overflow-wrap: break-word;
`;

const KoiiAirdrop = () => {
    const [output, setOutput] = useState('');

    useEffect(() => {
        fetch('http://localhost:5000/api/airdrop')
            .then(response => response.json())
            .then(data => setOutput(data.output))
            .catch(error => console.error('Error fetching airdrop:', error));
    }, []);

    return (
        <KoiiAirdropContainer>
            <OutputText>
                Output: {output}
            </OutputText>
        </KoiiAirdropContainer>
    );
};

export default KoiiAirdrop;
